import './MainPageSub03_1logo.scss';

import React, { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';

const MainPageSub03_1logo = () => {

    useEffect(() => {
        AOS.init({
            duration: 1500,
            easing: 'ease-in-out',
        });
    
    }, []);

    const text = "학업역량  종합진단평가  코칭프로그램 ";

    const colors = ["#B0B0B0", "#007B7B", "#D9771C", "#C3423F"];




    //=====================================================================
    return (
        <div className="MainPageSub03_1logo">

                <article className='art-circle'>

                    <div className='txt-i'>I</div>
                    
                    <div className="circle-container">
                    <div className="circle-text">
                        {text.split("").map((char, i) => (
                        <span
                            key={i}
                            style={{
                            transform: `rotate(${i * (360 / text.length)}deg)`,
                            color: colors[i % colors.length], // 순환하며 색상 변경
                            }}
                        >
                            {char}
                        </span>
                        ))}
                    </div>
                    </div> 
                </article>

        </div>
    );
};

export default MainPageSub03_1logo;
